const NO_SCROLL_CLASS = "no-scroll"

export const addNoScroll = (): void => {
    document.body.classList.add(NO_SCROLL_CLASS)
}

export const removeNoScroll = (): void => {
    document.body.classList.remove(NO_SCROLL_CLASS)
}